(() => {
  'use strict';

  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const words = value => String(value || '').toLowerCase().match(/[a-z0-9]+/g) || [];
  const aliases = {
    frame: 'finish',
    framefinish: 'finish',
    finishes: 'finish',
    fabric: 'upholstery',
    fabrics: 'upholstery',
    cushionfabric: 'upholstery',
    welt: 'welts',
    piping: 'welts',
    ropes: 'rope',
  };
  const featureKey = name => {
    const key = normalize(name);
    return aliases[key] || key;
  };

  // Keep option names: Fabric and Welt can contain the same material names.
  window.hrMapCylindoFeatures = (features, selected) => {
    const selections = Object.entries(selected).map(([name, value]) => ({
      key: featureKey(name),
      value: normalize(value),
      words: words(value),
    }));

    return features.flatMap(feature => {
      const options = feature.options || [];
      if (!options.length) return [];
      const keys = [featureKey(feature.code), featureKey(feature.name)];
      const selection = selections.find(item => keys.includes(item.key));
      const defaultOption = options.find(option => option.code === 'NONE') || options[0];
      let match = null;

      if (selection?.value) {
        match = options.find(option => normalize(option.name) === selection.value);
        // Some configurations include the feature name in the material label.
        if (!match) {
          match = options.find(option => {
            const name = normalize(option.name);
            return keys.some(key => key && (
              name === selection.value + key || name === key + selection.value
            ));
          });
        }
        if (!match) {
          // Shopify may omit words: "Travertine Grey" matches
          // "TRAVERTINE IRANIAN DARK GREY" within this feature only.
          let bestScore = 0;
          for (const option of options) {
            const optionWords = words(option.name);
            if (!selection.words.every(word => optionWords.includes(word))) continue;
            const score = selection.words.length / optionWords.length;
            if (score > bestScore) {
              bestScore = score;
              match = option;
            }
          }
        }
        if (!match) {
          console.warn('[cylindo] Material missing from feature configuration', {
            feature: feature.code,
            material: selection.value,
          });
        }
      }

      return [feature.code, (match || defaultOption).code];
    });
  };
})();
